import { ref } from 'vue';

/** Set by the video player so other analytics on the video page can share its per-view id. */
export const videoSessionId = ref<string | undefined>();
